import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '明星爆料', path: '/category/star-gossip' },
  { name: '网红黑料', path: '/category/influencer-drama' },
  { name: '聊天记录', path: '/category/chat-leaks' },
  { name: '每日大赛', path: '/category/daily-contest' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-fire-fill text-2xl text-primary-500"></i>
            </div>
            <span className="text-lg font-bold font-heading text-foreground-900 whitespace-nowrap">
              51吃瓜app
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                    isActive
                      ? 'text-primary-500 font-medium'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3 flex-shrink-0">
            <a
              href="#download"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>下载App</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line text-sm"></i>
              </div>
            </a>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`text-xl text-foreground-900 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </div>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2.5 rounded-lg text-sm transition-colors ${
                    isActive
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
            <a
              href="#download"
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <span>下载App</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}